import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { HistoricalView } from '@/domain/types/historical';
import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from 'firebase/firestore';
import { useCallback, useState } from 'react';
import { ReportEmployee } from '../types';

const useReportEmployee = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  const fetchData = useCallback(
    async ({
      document,
      startDate,
      endDate,
    }: {
      document: string;
      startDate: Date | null;
      endDate: Date | null;
    }) => {
      setIsLoading(true);
      const collectionRef = collection(db, DOCUMENTS_DB.HISTORICAL);

      const filters: QueryConstraint[] = [];

      if (document) filters.push(where('document', '==', document));
      if (startDate) filters.push(where('date', '>=', startDate));
      if (endDate) {
        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(23, 59, 59, 999);
        filters.push(where('date', '<=', adjustedEndDate));
      }

      const q = query(collectionRef, ...filters);

      const querySnapshot = await getDocs(q);
      console.log(querySnapshot.docs.length);
      const data: HistoricalView[] = [];

      querySnapshot.forEach((doc) => {
        const d = doc.data() as HistoricalView & { isUserBlocked?: boolean };
        if (!d.isUserBlocked) {
          data.push(d);
        }
      });

      const groupedData = data.reduce((acc, curr) => {
        const existingItem = acc.find(
          (item) => item.collectionId === curr.collectionId,
        );
        if (existingItem) {
          existingItem.views += 1;
        } else {
          acc.push({ ...curr, views: 1, id: (acc.length + 1).toString() });
        }
        return acc;
      }, [] as ReportEmployee[]);

      console.log(groupedData);

      setData(groupedData);

      setIsLoading(false);
    },
    [],
  );

  const clearData = useCallback(() => {
    setData([]);
  }, []);

  return { isLoading, data, fetchData, clearData };
};

export default useReportEmployee;
